(() => {
  const normalize = (value) => {
    const match = value.trim().match(/^([A-Za-z0-9]{4})\.([A-Za-z0-9]{2})$/);
    return match && /\d/.test(value) ? match[1] + match[2] : value;
  };
  window.pwNormalizeOeQuery = normalize;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !action.pathname.endsWith('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (input) input.value = normalize(input.value);
  }, true);
  const normalizeInitialQuery = () => {
    const url = new URL(window.location.href);
    if (!url.pathname.endsWith('/search')) return;
    const query = url.searchParams.get('q');
    if (!query) return;
    const normalized = normalize(query);
    if (normalized !== query) {
      url.searchParams.set('q', normalized);
      window.location.replace(url.toString());
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeInitialQuery, { once: true });
  else normalizeInitialQuery();
})();
